var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('b-button',{attrs:{"variant":"primary"},on:{"click":_vm.resample}},[_vm._v("Generate Again!")])],1),_vm._v(" "),_c('div',_vm._l((_vm.sample),function(s){return _c('span',[_c('l-display',{attrs:{"system":s,"width":"67","height":"126"}})],1)}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1778f529","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GA.vue
// module id = null
// module chunks = 